module.exports = __webpack_public_path__ + "assets/check-in-bg-12bf42e4.png";